// plugins/tooltip‑directive.js
export default defineNuxtPlugin(nuxtApp => {
    // only register if not already present
    const app = nuxtApp.vueApp;
    if (!app._context.directives.tooltip) {
        app.directive('tooltip', {
            mounted(el, binding) {
                const handleMouseEnter = () => {
                    const position = Object.keys(binding.modifiers)[0] || 'default';
                    // …
                };
                el.addEventListener('mouseenter', handleMouseEnter);
                el.__vueTooltip__ = handleMouseEnter;
            },
            beforeUnmount(el) {
                if (el.__vueTooltip__) {
                    el.removeEventListener('mouseenter', el.__vueTooltip__);
                }
            }
        });
    }
});
